/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminthreads_Coltitle2Inputs */

const zh_adminthreads_coltitle2 = /** @type {(inputs: Adminthreads_Coltitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标题`)
};

const en_adminthreads_coltitle2 = /** @type {(inputs: Adminthreads_Coltitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const es_adminthreads_coltitle2 = /** @type {(inputs: Adminthreads_Coltitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título`)
};

/**
* | output |
* | --- |
* | "Title" |
*
* @param {Adminthreads_Coltitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminthreads_coltitle2 = /** @type {((inputs?: Adminthreads_Coltitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminthreads_Coltitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminthreads_coltitle2(inputs)
	if (locale === "en") return en_adminthreads_coltitle2(inputs)
	return es_adminthreads_coltitle2(inputs)
});
export { adminthreads_coltitle2 as "adminThreads_colTitle" }